// @flow
import { ConfRegActionTypes } from './constants';

type ConfRegAction = { type: string, payload: {} | string };

// common success
export const confRegApiResponseSuccess = (actionType: string, data: any): ConfRegAction => ({
    type: ConfRegActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const confRegApiResponseError = (actionType: string, error: string): ConfRegAction => ({
    type: ConfRegActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getConfReg = (id: string): ConfRegAction => ({
    type: ConfRegActionTypes.GET_CONF_REG,
    payload: { id },
});

export const addConfReg = (confReg:any):ConfRegAction=>({
    type:ConfRegActionTypes.ADD_CONF_REG,
    payload:confReg
})
export const updateConfReg = (confReg:any):ConfRegAction=>({
    type:ConfRegActionTypes.UPDATE_CONF_REG,
    payload:confReg
})
export const deleteConfReg = (id:string):ConfRegAction=>({
    type:ConfRegActionTypes.DELETE_CONF_REG,
    payload:{id}
})

export const listConfReg = (params:any): ConfRegAction => ({
    type: ConfRegActionTypes.LIST_CONF_REG,
    payload: params,
});

export const setFiltersConfReg = (params:any): ConfRegAction => ({
    type: ConfRegActionTypes.SET_FILTER,
    payload: params,
})

export const resetConfReg = (): ConfRegAction => ({
    type: ConfRegActionTypes.RESET,
    payload: {},
});

